var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import { NavArrow, NavCurrency, NavCurrencyItem, NavCurrencyModal, NavCurrencyModalSymbol, NavCurrencySymbol, NavLink, NavRegionCountriesDivider, NavRegionCountriesList, NavRegionCountryItem, NavRegionFilter, NavRegionFlag, NavRegionInsideFlag, NavRegionMenuInput, NavRegionModal, NavRegionSearchIcon, NavRegionSearchNoResult, NavShipTo, NavShipToArrow, NavShipToModal, NavShipToModalTitle, NavShipToModule, NavShipToSaveButton, NavShipToSelection, NavShipToSelectionToggle, NavShipToSelectionToggleText, NavSlash } from "./styles";
import { Triangle, TriangleShadow } from "../../styles";
import getLangKeyValueFun from "../../../../utils/lang";
import langGroup from "../../../../assets/lang.json";
import { AssetImageUrl } from "../../../../assets/imgUrl";
import { WebCountryFlagPosition } from "../../../../utils/constant";
import Constant from "../../../../utils/constant";
import setSession from "../../../../services/session";
import { lsGetItem, lsSetItem } from "../../../../utils/safeWebStorage";
const getText = getLangKeyValueFun(langGroup);
class ShipTo extends React.Component {
    constructor(props) {
        super(props);
        this.getRegionFlagPosition = (regionISOCode) => {
            const isoCode = regionISOCode ? regionISOCode.toLocaleLowerCase() : "";
            return WebCountryFlagPosition[isoCode];
        };
        this.onChangeModalStatus = (e) => {
            const recentCountriesFromStorage = lsGetItem("RECENTCOUNTRIES") || "[]";
            e.stopPropagation();
            this.setState({
                showModal: !this.state.showModal,
                showRegionModal: false,
                showCurrencyModal: false,
                recentCountries: JSON.parse(recentCountriesFromStorage) || []
            });
        };
        this.onClickNonSelectionArea = (e) => {
            e.stopPropagation();
            this.setState({
                showRegionModal: false,
                showCurrencyModal: false
            });
        };
        this.onClickNonSelectionSubArea = (e) => {
            e.stopPropagation();
        };
        this.onChangeRegionModalStatus = (e) => {
            e.stopPropagation();
            this.setState({
                showRegionModal: !this.state.showRegionModal,
                showCurrencyModal: false
            });
        };
        this.onChangeCurrencyModalStatus = (e) => {
            e.stopPropagation();
            this.setState({
                showCurrencyModal: !this.state.showCurrencyModal,
                showRegionModal: false
            });
        };
        this.onChangeSearchText = (e) => {
            this.setState({
                searchText: e.target.value
            });
        };
        this.onChangeUserCountry = (newUserCountry) => {
            const { currencies = [] } = this.props;
            const newUserCurrency = currencies.find(cr => cr.currency_code === newUserCountry.defaultCurrency);
            this.setState({
                newUserCountry,
                newUserCurrency,
                showRegionModal: false
            });
        };
        this.onChangeUserCurrency = (newUserCurrency) => {
            this.setState({
                newUserCurrency,
                showCurrencyModal: false
            });
        };
        this.onSaveLocalStorage = () => {
            const { newUserCountry } = this.state;
            let localStorageList = [];
            try {
                localStorageList = JSON.parse(lsGetItem("RECENTCOUNTRIES")) || [];
            }
            catch (e) {
                localStorageList = [];
            }
            if (!localStorageList.some(i => i.country_id === newUserCountry.countryId)) {
                localStorageList.unshift(newUserCountry);
                lsSetItem("RECENTCOUNTRIES", JSON.stringify(localStorageList));
            }
        };
        this.onSave = () => __awaiter(this, void 0, void 0, function* () {
            const { newUserCountry, newUserCurrency } = this.state;
            this.onSaveLocalStorage();
            if (newUserCountry === null || newUserCountry === void 0 ? void 0 : newUserCountry.countryIsoCode2) {
                Constant.countryCode2 = newUserCountry.countryIsoCode2;
            }
            if (newUserCurrency === null || newUserCurrency === void 0 ? void 0 : newUserCurrency.currency_code) {
                Constant.currency = newUserCurrency.currency_code;
            }
            yield setSession({
                countryCode: newUserCountry === null || newUserCountry === void 0 ? void 0 : newUserCountry.countryIsoCode2,
                currencyCode: newUserCurrency === null || newUserCurrency === void 0 ? void 0 : newUserCurrency.currency_code
            });
            location.reload();
        });
        const { countries = [], popularCounties = [], userCurrency = {} } = props;
        this.state = {
            showModal: false,
            showRegionModal: false,
            showCurrencyModal: false,
            newUserCountry: props.userCountry,
            newUserCurrency: userCurrency,
            searchText: "",
            allCountries: [...countries, ...popularCounties],
            recentCountries: []
        };
    }
    componentDidMount() {
        window.addEventListener("click", () => {
            this.setState({
                showModal: false,
                showRegionModal: false,
                showCurrencyModal: false
            });
        });
    }
    componentDidUpdate(prevProps) {
        const { userCountry, userCurrency } = this.props;
        if (prevProps.userCountry !== userCountry) {
            this.setState({
                newUserCountry: userCountry
            });
        }
        if (prevProps.userCurrency !== userCurrency) {
            this.setState({
                newUserCurrency: userCurrency
            });
        }
    }
    render() {
        const { userCountry, currencies = [], userCurrency, countries = [], popularCounties = [] } = this.props;
        const { showModal, showRegionModal, showCurrencyModal, newUserCountry, newUserCurrency, searchText } = this.state;
        const filterCountries = countries.filter(i => i.countryName.toLocaleLowerCase().indexOf(searchText.toLocaleLowerCase()) !== -1);
        const filterRecentCountries = popularCounties.filter(i => i.countryName.toLocaleLowerCase().indexOf(searchText.toLocaleLowerCase()) !== -1);
        return (React.createElement(NavShipToModule, { onClick: this.onChangeModalStatus },
            React.createElement(NavLink, null,
                React.createElement(NavShipTo, null,
                    getText("Ship to"),
                    ":"),
                React.createElement(NavRegionFlag, { style: {
                        backgroundPosition: this.getRegionFlagPosition(userCountry === null || userCountry === void 0 ? void 0 : userCountry.countryIsoCode2)
                    } }),
                React.createElement(NavSlash, null, "/"),
                (userCurrency === null || userCurrency === void 0 ? void 0 : userCurrency.currency_symbol) || "$",
                " ", userCurrency === null || userCurrency === void 0 ? void 0 :
                userCurrency.currency_code,
                React.createElement(NavArrow, { className: showModal && "isShow", style: { marginLeft: 5.5 } })),
            showModal && (React.createElement(NavShipToModal, { onClick: this.onClickNonSelectionArea },
                React.createElement(Triangle, { style: { left: "65%" } }),
                React.createElement(TriangleShadow, { style: { left: "65%" } }),
                React.createElement(NavShipToModalTitle, null,
                    getText("Ship to"),
                    ":"),
                React.createElement(NavShipToSelection, { onClick: this.onChangeRegionModalStatus },
                    React.createElement(NavShipToSelectionToggle, null,
                        React.createElement(NavRegionFlag, { style: {
                                backgroundPosition: this.getRegionFlagPosition(newUserCountry === null || newUserCountry === void 0 ? void 0 : newUserCountry.countryIsoCode2),
                                margin: "2px 9px 1px 0px"
                            } }),
                        React.createElement(NavShipToSelectionToggleText, null, newUserCountry === null || newUserCountry === void 0 ? void 0 : newUserCountry.countryName),
                        React.createElement(NavShipToArrow, { className: showRegionModal && "open" })),
                    showRegionModal && (React.createElement(NavRegionModal, { onClick: this.onClickNonSelectionSubArea },
                        React.createElement(NavRegionFilter, null,
                            React.createElement(NavRegionSearchIcon, { src: AssetImageUrl["ic_search@3x.png"] }),
                            React.createElement(NavRegionMenuInput, { value: searchText, onChange: this.onChangeSearchText, placeholder: getText("Search") })),
                        React.createElement(NavRegionCountriesList, null,
                            !searchText &&
                                popularCounties.map(item => (React.createElement(NavRegionCountryItem, { key: item.countryId, onClick: () => this.onChangeUserCountry(item) },
                                    React.createElement(NavRegionInsideFlag, { style: {
                                            backgroundPosition: this.getRegionFlagPosition(item === null || item === void 0 ? void 0 : item.countryIsoCode2)
                                        } }),
                                    React.createElement("span", null, item.countryName)))),
                            searchText &&
                                0 in filterRecentCountries &&
                                filterRecentCountries.map(item => (React.createElement(NavRegionCountryItem, { key: item.countryId, onClick: () => this.onChangeUserCountry(item) },
                                    React.createElement(NavRegionInsideFlag, { style: {
                                            backgroundPosition: this.getRegionFlagPosition(item === null || item === void 0 ? void 0 : item.countryIsoCode2)
                                        } }),
                                    React.createElement("span", null, item.countryName)))),
                            React.createElement(NavRegionCountriesDivider, null),
                            !searchText &&
                                countries.map(item => (React.createElement(NavRegionCountryItem, { key: item.countryId, onClick: () => this.onChangeUserCountry(item) },
                                    React.createElement(NavRegionInsideFlag, { style: {
                                            backgroundPosition: this.getRegionFlagPosition(item === null || item === void 0 ? void 0 : item.countryIsoCode2)
                                        } }),
                                    React.createElement("span", null, item === null || item === void 0 ? void 0 : item.countryName)))),
                            searchText &&
                                0 in filterCountries &&
                                filterCountries.map(item => (React.createElement(NavRegionCountryItem, { key: item.countryId, onClick: () => this.onChangeUserCountry(item) },
                                    React.createElement(NavRegionInsideFlag, { style: {
                                            backgroundPosition: this.getRegionFlagPosition(item === null || item === void 0 ? void 0 : item.countryIsoCode2)
                                        } }),
                                    React.createElement("span", null, item.countryName)))),
                            searchText &&
                                !(0 in filterCountries || 0 in filterRecentCountries) && (React.createElement(NavRegionSearchNoResult, null,
                                getText("No result match"),
                                `"${searchText}"`)))))),
                React.createElement(NavShipToModalTitle, null,
                    getText("Currency"),
                    ":"),
                React.createElement(NavShipToSelection, { onClick: this.onChangeCurrencyModalStatus },
                    React.createElement(NavShipToSelectionToggle, null,
                        React.createElement(NavCurrencySymbol, null, newUserCurrency === null || newUserCurrency === void 0 ? void 0 : newUserCurrency.currency_symbol),
                        React.createElement(NavShipToSelectionToggleText, null, newUserCurrency === null || newUserCurrency === void 0 ? void 0 : newUserCurrency.currency_code),
                        React.createElement(NavShipToArrow, { className: showCurrencyModal && "open" })),
                    showCurrencyModal && (React.createElement(NavCurrencyModal, { onClick: this.onClickNonSelectionSubArea }, currencies.map(item => (React.createElement(NavCurrencyItem, { key: item.sort_order },
                        React.createElement(NavCurrency, { onClick: () => this.onChangeUserCurrency(item) },
                            React.createElement(NavCurrencyModalSymbol, null,
                                item.currency_symbol,
                                " ",
                                ""),
                            item.currency_code))))))),
                React.createElement(NavShipToSaveButton, { onClick: this.onSave }, getText("Save"))))));
    }
}
export default ShipTo;
